module.exports = __webpack_public_path__ + "img/shift-illustration.b3bd4e1f.svg";